import apiClient from './index';

const BASE_URL = '/adss/v1/shared-notes';

// === Shared Notes ===

export const getNotes = async (skip = 0, limit = 10, roleId = null, search = null) => {
  try {
    const params = { skip, limit };
    if (roleId !== null) {
      params.role_id = roleId;
    }
    if (search !== null && search.trim() !== '') {
      params.search = search.trim();
    }
    
    const response = await apiClient.get(`${BASE_URL}/`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching shared notes:', error);
    throw error;
  }
};

export const getNote = async (noteId) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/${noteId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shared note:', error);
    throw error;
  }
};

export const createNote = async (noteData) => {
  try {
    const response = await apiClient.post(`${BASE_URL}/`, noteData);
    return response.data;
  } catch (error) {
    console.error('Error creating shared note:', error);
    throw error;
  }
};

export const updateNote = async (noteId, noteData) => {
  try {
    const response = await apiClient.put(`${BASE_URL}/${noteId}`, noteData);
    return response.data;
  } catch (error) {
    console.error('Error updating shared note:', error);
    throw error;
  }
};

export const deleteNote = async (noteId) => {
  try {
    const response = await apiClient.delete(`${BASE_URL}/${noteId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting shared note:', error);
    throw error;
  }
};

// === Version History ===

export const getNoteVersions = async (noteId, skip = 0, limit = 10) => {
  try {
    const params = { skip, limit };
    const response = await apiClient.get(`${BASE_URL}/${noteId}/versions`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching note versions:', error);
    throw error;
  }
};

// === User Management ===

export const getUsersForEditorAssignment = async () => {
  try {
    const response = await apiClient.get(`${BASE_URL}/users/list`);
    return response.data;
  } catch (error) {
    console.error('Error fetching users for editor assignment:', error);
    throw error;
  }
};